import React from "react";
import { FiLayers } from "react-icons/fi";

const TShirtsStockingMenuItem = (name: string) => {
    return [
        <FiLayers key={`${name}-icon`} size={"1.5em"} />,
        <div key={`${name}-text`}>
            <span>{name}</span>
        </div>,
    ];
};

export default TShirtsStockingMenuItem;
